(function() {
    let htwotaganimate = document.querySelectorAll('.main-page-experiences-header-details > h2');
    let hthreetaganimate = document.querySelectorAll('.main-page-experiences-header-details > h3');
    let headerbanneranimate = document.querySelectorAll('.main-page-experiences-header > img');

    document.addEventListener("DOMContentLoaded", () => {          
        setTimeout(() => {
            console.log('loaded 1')
            headerbanneranimate.forEach(element => {
                element.classList.add('loaded');
            });
        },500);
        setTimeout(() => {
            console.log('loaded 2')
            htwotaganimate.forEach(element => {
                element.classList.add('loaded');
            });
            hthreetaganimate.forEach(element => {
                element.classList.add('loaded');
            });
        },1000);
    }); 
    
})();